import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";

function LanguageSwitcher() {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);

        // Ensure language is always persisted
        localStorage.setItem("i18nextLng", lng);

        // Sync with ASP.NET Core Culture Cookie
        document.cookie = `.AspNetCore.Culture=c=${lng}|uic=${lng}; path=/; max-age=31536000`;
    };

    return (
        <div style={{ textAlign: "right", padding: "10px" }}>
            <Button
                variant="contained"
                color="primary"
                onClick={() => changeLanguage("bg")}
                style={{ marginRight: "10px" }}
            >
                BG
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={() => changeLanguage("en")}
            >
                EN
            </Button>
        </div>
    );
}

export default LanguageSwitcher;





//import React from "react";
//import { useTranslation } from "react-i18next";
//import Button from "@material-ui/core/Button";

//function LanguageSwitcher() {
//    const { i18n } = useTranslation();

//    const changeLanguage = (lng) => {
//        i18n.changeLanguage(lng);

//        // Sync with ASP.NET Core cookie format: c=xx|uic=xx
//        document.cookie = `.AspNetCore.Culture=c=${lng}|uic=${lng}; path=/; max-age=31536000`;
//    };

//    return (
//        <div style={{ textAlign: "right", padding: "10px" }}>
//            <Button
//                variant="contained"
//                color="primary"
//                onClick={() => changeLanguage("bg")}
//                style={{ marginRight: "10px" }}
//            >
//                БГ
//            </Button>
//            <Button
//                variant="contained"
//                color="primary"
//                onClick={() => changeLanguage("en")}
//            >
//                EN
//            </Button>
//        </div>
//    );
//}

//export default LanguageSwitcher;




//import React from "react";
//import { useTranslation } from "react-i18next";
//import Button from "@material-ui/core/Button";
//import axios from "axios";

//function LanguageSwitcher() {
//    const { i18n } = useTranslation("common");

//    const changeLanguage = (lng) => {
//        // Update client translations immediately
//        i18n.changeLanguage(lng);

//        // Send language to backend so it sets cookie
//        axios.post("/api/language/set", { culture: lng }, { withCredentials: true })
//            .then(() => {
//                // OK — cookie should be set by the server
//            })
//            .catch((err) => {
//                console.error("Error setting language cookie:", err);
//            });
//    };

//    return (
//        <div style={{ textAlign: "right", padding: "10px" }}>
//            <Button
//                variant="contained"
//                color={i18n.language === "bg" ? "secondary" : "primary"}
//                onClick={() => changeLanguage("bg")}
//                style={{ marginRight: "10px" }}
//            >
//                🇧🇬 БГ
//            </Button>
//            <Button
//                variant="contained"
//                color={i18n.language === "en" ? "secondary" : "primary"}
//                onClick={() => changeLanguage("en")}
//            >
//                🇬🇧 EN
//            </Button>
//        </div>
//    );
//}

//export default LanguageSwitcher;


//import React from "react";
//import { useTranslation } from "react-i18next";
//import Button from "@material-ui/core/Button";
//import axios from "axios";

//function LanguageSwitcher() {
//    const { i18n } = useTranslation("common");

//    const changeLanguage = (lng) => {
//        // Update i18n immediately
//        i18n.changeLanguage(lng);

//        // Send language to backend (POST body)
//        axios.post("/api/language/set", { culture: lng })
//            .then(() => {
//                console.log(`Language changed to ${lng}`);
//            })
//            .catch((err) => {
//                console.error("Error setting language:", err);
//            });
//    };

//    return (
//        <div style={{ textAlign: "right", padding: "10px" }}>
//            <Button
//                variant="contained"
//                color={i18n.language === "bg" ? "secondary" : "primary"}
//                onClick={() => changeLanguage("bg")}
//                style={{ marginRight: "10px" }}
//            >
//                🇧🇬 БГ
//            </Button>
//            <Button
//                variant="contained"
//                color={i18n.language === "en" ? "secondary" : "primary"}
//                onClick={() => changeLanguage("en")}
//            >
//                🇬🇧 EN
//            </Button>
//        </div>
//    );
//}

//export default LanguageSwitcher;


//import React from "react";
//import { useTranslation } from "react-i18next";
//import Button from "@material-ui/core/Button";
//import axios from "axios";

//function LanguageSwitcher() {
//    const { i18n } = useTranslation("common");

//    const changeLanguage = (lng) => {
//        // Update client translations immediately
//        i18n.changeLanguage(lng);

//        // Tell backend to set cookie
//        axios.post(`/api/language/set?culture=${lng}`)
//            .then(() => {
//                console.log(`Language changed to ${lng}`);
//            })
//            .catch((err) => {
//                console.error("Error setting language:", err);
//            });
//    };

//    return (
//        <div style={{ textAlign: "right", padding: "10px" }}>
//            <Button
//                variant="contained"
//                color={i18n.language === "bg" ? "secondary" : "primary"}
//                onClick={() => changeLanguage("bg")}
//                style={{ marginRight: "10px" }}
//            >
//                🇧🇬 БГ
//            </Button>
//            <Button
//                variant="contained"
//                color={i18n.language === "en" ? "secondary" : "primary"}
//                onClick={() => changeLanguage("en")}
//            >
//                🇬🇧 EN
//            </Button>
//        </div>
//    );
//}

//export default LanguageSwitcher;



//import React from "react";
//import { useTranslation } from "react-i18next"; // Import useTranslation
//import Button from "@material-ui/core/Button";

//function LanguageSwitcher() {
//    const { i18n } = useTranslation("common"); // Destructure i18n from useTranslation

//    const changeLanguage = (lng) => {
//        i18n.changeLanguage(lng); // Change the language
//    };

//    return (
//        <div style={{ textAlign: "right", padding: "10px" }}>
//            <Button
//                variant="contained"
//                color="primary"
//                onClick={() => changeLanguage("bg")}
//                style={{ marginRight: "10px" }}
//            >
//                БГ
//            </Button>
//            <Button
//                variant="contained"
//                color="primary"
//                onClick={() => changeLanguage("en")}
//            >
//                EN
//            </Button>
//        </div>
//    );
//}

//export default LanguageSwitcher;